import React from 'react'
import DataItem from './DataItem'
import "./aside.css";
import { useAuth0 } from "@auth0/auth0-react"


const claves = ["No", "NAME","TYPE", "OT","IDNo","ITEM"]

export default function DataAside({localData, apiData}) {

    const { user } = useAuth0();
    let name = localData.user? user.given_name : localData.name 

    const objToPrint = {
        "No": apiData.id,
        "NAME": name,
        "TYPE": apiData.types,
        "OT": localData.originalTrainer,
        "IDNo": localData.IDNo,
        "ITEM": localData.item
    }
    const arrValues = Object.values(objToPrint)

    return (
        <aside className="data">
            {
                claves.map((clave, indice) =>{
                    return <DataItem clave={clave} valor={arrValues[indice]} key={"data-item" + indice}/>
                })
            }
        </aside>
    )
}
